import { setIsLoading, setSuccess, setError } from './submit-email-slice';
import { dataCaptureForm } from 'api/data-capture-form';
import { getErrors } from 'api/client';

export const ErrorInvalidEmail = {
  message: 'Invalid email address'
};

export const submitEmailThunk = ({ email, salesSubChannel }) => async (
  dispatch
) => {
  try {
    dispatch(setIsLoading());
    const response = await dataCaptureForm({
      topic: 'join-nep-interest',
      email,
      salesSubChannel
    });

    dispatch(setSuccess(response));
    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
